import {del, post, put} from "../util/http.service";

export const createTransaction = transaction => post("/transactions", transaction);

export const updateTransaction = (id, transaction) => put("/transactions/" + id, transaction);

export const deleteTransaction = transaction => del("/transactions/" + transaction.id);

export const sendTransactionAction = action => post("/transactions/actions", action);
